import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "themchuyennganh",
  style: {"font-weight":"bold"}
}, "Thêm chuyên ngành", -1)
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "thembt",
  style: {"font-weight":"bold"}
}, "Thêm", -1)
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_10 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_11 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_14 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "themlinhvuc",
  style: {"font-weight":"bold"}
}, "Thêm lĩnh vực", -1)
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "themlinhvucbt",
  style: {"font-weight":"bold"}
}, "Thêm", -1)
const _hoisted_19 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_20 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_21 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_23 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_24 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_25 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "themcapdo",
  style: {"font-weight":"bold"}
}, "Thêm cấp độ", -1)
const _hoisted_27 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "themcapdobt",
  style: {"font-weight":"bold"}
}, "Thêm", -1)
const _hoisted_29 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_30 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_31 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    style: {"text-align":"center"},
    header: "Cấu hình thông số"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Panel, {
              style: {"text-align":"center"},
              header: "Chuyên nghành"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_InputText, {
                      id: "themchuyennganh",
                      type: "phone",
                      modelValue: $setup.chuyenNganhCreate.tenChuyenNganh,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.chuyenNganhCreate.tenChuyenNganh) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_Button, {
                      id: "thembt",
                      label: "Thêm chuyên ngành",
                      type: "button",
                      icon: "pi pi-plus-circle",
                      align: "center",
                      onClick: $setup.createChuyenNganh
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_DataTable, {
                      value: $setup.dsChuyenNganh,
                      paginator: true,
                      stripedRows: "",
                      rows: 10,
                      rowsPerPageOptions: [10,25,50],
                      rowHover: true,
                      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                      filters: $setup.filters,
                      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters) = $event)),
                      globalFilterFields: ['tenChuyenNganh'],
                      currentPageReportTemplate: "Có tổng số {totalRecords} chuyên ngành",
                      columnResizeMode: "fit | expand"
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, [
                            _hoisted_12,
                            _createVNode(_component_InputText, {
                              modelValue: $setup.filters['global'].value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters['global'].value) = $event)),
                              placeholder: "Tìm theo chuyên ngành"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          field: "tenChuyenNganh",
                          header: "Tên chuyên ngành",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, { header: "Chỉnh sửa" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              class: "p-button-danger",
                              label: "Xóa",
                              icon: "pi pi-trash",
                              onClick: ($event: any) => ($setup.deleteChuyenNganh(slotProps.data.id)),
                              style: {"width":"10vw"}
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value", "filters"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Panel, {
              style: {"text-align":"center"},
              header: "Lĩnh vực"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_InputText, {
                      id: "themlinhvuc",
                      type: "phone",
                      modelValue: $setup.linhVucCreate.tenLinhVuc,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.linhVucCreate.tenLinhVuc) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_Button, {
                      id: "themlinhvucbt",
                      label: "Thêm chuyên ngành",
                      type: "button",
                      icon: "pi pi-plus-circle",
                      align: "center",
                      onClick: $setup.createLinhVuc
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_DataTable, {
                      value: $setup.dsLinhVuc,
                      paginator: true,
                      stripedRows: "",
                      rows: 10,
                      rowsPerPageOptions: [10,25,50],
                      rowHover: true,
                      filters: $setup.filters2,
                      "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters2) = $event)),
                      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                      globalFilterFields: ['tenLinhVuc'],
                      currentPageReportTemplate: "Có tổng số {totalRecords} lĩnh vực",
                      columnResizeMode: "fit | expand"
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, [
                            _hoisted_22,
                            _createVNode(_component_InputText, {
                              modelValue: $setup.filters2['global'].value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters2['global'].value) = $event)),
                              placeholder: "Tìm theo lĩnh vực"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          field: "tenLinhVuc",
                          header: "Tên lĩnh vực",
                          sortable: "",
                          style: {"width":"20vw"}
                        }),
                        _createVNode(_component_Column, { header: "Chỉnh sửa" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              class: "p-button-danger",
                              label: "Xóa",
                              icon: "pi pi-trash",
                              onClick: ($event: any) => ($setup.deleteLinhVuc(slotProps.data.id)),
                              style: {"width":"10vw"}
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value", "filters"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_Panel, {
              style: {"text-align":"center"},
              header: "Cấp độ"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_InputText, {
                      id: "themcapdo",
                      type: "phone",
                      modelValue: $setup.capDoCreate.capDoDeTai,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.capDoCreate.capDoDeTai) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_Button, {
                      id: "themcapdobt",
                      label: "Thêm cấp độ",
                      type: "button",
                      icon: "pi pi-plus-circle",
                      align: "center",
                      onClick: $setup.createCapDo
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_DataTable, {
                      value: $setup.dsCapDo,
                      paginator: true,
                      stripedRows: "",
                      rows: 10,
                      rowsPerPageOptions: [10,25,50],
                      rowHover: true,
                      filters: $setup.filters3,
                      "onUpdate:filters": _cache[8] || (_cache[8] = ($event: any) => (($setup.filters3) = $event)),
                      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                      globalFilterFields: ['capDoDeTai'],
                      currentPageReportTemplate: "Có tổng số {totalRecords} cấp độ",
                      columnResizeMode: "fit | expand"
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, [
                            _hoisted_32,
                            _createVNode(_component_InputText, {
                              modelValue: $setup.filters3['global'].value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.filters3['global'].value) = $event)),
                              placeholder: "Tìm theo cấp độ"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          field: "capDoDeTai",
                          header: "Tên cấp độ",
                          sortable: "",
                          style: {"width":"20vw"}
                        }),
                        _createVNode(_component_Column, { header: "Chỉnh sửa" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              class: "p-button-danger",
                              label: "Xóa",
                              icon: "pi pi-trash",
                              onClick: ($event: any) => ($setup.deleteCapDo(slotProps.data.id)),
                              style: {"width":"10vw"}
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value", "filters"])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}